import moment from 'moment'

export default (value, format = 'MM/DD/YYYY hh:mm A') => {
  if (!value) {
    return ''
  }

  return moment(value).format(format)
}
